<template>
    <div class="table-wrapper" style="padding-top: 30px">
        <Row :gutter="24">
            <Col span="12">
                <div class="fchart-box">
                    <div class="aFlex fchart-box-top">
                        <span class="ft-bold">工资保证金描述</span>
                        <!--<span class="ft-gray" style="margin-left: 10px">默认统计系统日期上个月</span>-->
                    </div>
                    <div class="fchart-bi" ref="depositPie">工资保证金描述</div>
                </div>
            </Col>
            <Col span="12">
                <div class="fchart-box">
                    <div class="aFlex fchart-box-top">
                        <span class="ft-bold">动用工资保证金</span>
                    </div>
                    <div class="fchart-bi" ref="depositGauge">动用工资保证金</div>
                </div>
            </Col>
        </Row>
        <div class="fchart-box">
            <div class="aFlex fchart-box-top">
                <span class="ft-bold">各地市缴纳保证金项目分布</span>
            </div>
            <div class="fchart-bi" ref="depositScatter">各地市缴纳保证金项目分布</div>
        </div>


    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState} from 'vuex';
    export default {
        data(){
            return {
                // 工资保证金饼图
                depositPie:null,
                // 保证金仪表盘
                depositGauge:null,
                // 保证金散点图
                depositScatter:null,
                areaCode: localStorage.getItem('tenantAreaCode')
            };
        },
        computed:{
        },
        watch: {
            areaCode: function () {
                this.getPageData();
            },
        },
        created(){
        },
        mounted(){
            // 引入echarts 初始化图标
            let echarts = require('echarts');
            // 保证金饼图
            this.depositPie = echarts.init(this.$refs.depositPie);
            // 保证金仪表盘
            this.depositGauge = echarts.init(this.$refs.depositGauge);
            // 保证金散点图
            this.depositScatter = echarts.init(this.$refs.depositScatter);
            //初始化 setOption
            this.initChart();
            //获取数据
            this.getPageData();
            window.addEventListener('resize',this.resize);
            window.addEventListener('load',this.resize);
            /*加载完成自适应*/
            this.$nextTick( ()=> {
                this.resize();
            });
        },
        methods: {
            // echarts 适应
            resize(){
                this.depositPie.resize();
                this.depositGauge.resize();
                this.depositScatter.resize();
            },
            initChart(){
                this.depositPie.setOption(
                    {
                        title:{
                            textStyle:{
                                color: '#999999',
                                fontSize:13,
                                fontWeight:400
                            },
                            textAlign:'center',
                            right:'10%',
                            bottom: 15,
                            text: '项目总数: 0个',
                        },
                        legend: {
                            orient: 'horizontal',
                            bottom:15,
                            right:'40%',
                            icon:'circle',
                        },
                        tooltip: {
                            trigger: 'item',
                            formatter: '{b} : {c} ({d}%)'
                        },
                        color:['#3AA1FF','#36CBCB'],
                        series: [
                            {
                                type: 'pie',
                                center: ['50%', '43%'],
                                radius:['40%', '65%'],
                                label:{
                                    show:true,
                                    formatter:(params)=>{
                                        return `${params.name}: ${params.percent}%`
                                    }
                                },
                                itemStyle: { //图形样式
                                    normal: {
                                        borderColor: '#ffffff',
                                        borderWidth: 2,
                                    },
                                },
                                data:[{"name":"已缴纳","value":"0"},{"name":"未缴纳","value":"0"}]
                            }
                        ]
                    }
                );
                // 保证金仪表盘
                this.depositGauge.setOption(
                    {
                        tooltip: {
                            // trigger: 'item',
                            // formatter: '{b} : {c} ({d}%)'
                            // formatter: '{a} <br/>{b} : {c}%'
                        },
                        series: [
                            {
                                name: '动用工资保证金',
                                type: 'gauge',
                                detail: {formatter: '{value}%'},
                                data:[{"name":"使用率","value":"0"}]
                            }
                        ]
                    }
                );
                // 保证金散点图
                this.depositScatter.setOption(
                    {
                        tooltip: {
                            formatter: function (params) {
                                return params.value[0] + ':  ' + params.value[1] + params.value[2]+'个项目';
                            }
                        },
                        grid: {
                            left: 40,
                            top: 30,
                            bottom: 30,
                            right: 40,
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: [],
                            boundaryGap: false,
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: '#999',
                                    type: 'dashed'
                                }
                            },
                            axisLine: {
                                show: false
                            }
                        },
                        yAxis: {
                            type: 'category',
                            data: [],
                            axisLine: {
                                show: false
                            }
                        },
                        series: [{
                            name: '各地市缴纳保证金项目分布',
                            type: 'scatter',
                            symbolSize: function (val) {
                                return Math.max(val[2] / 10, 8);
                            },
                            data: [],
                            animationDelay: function (idx) {
                                return idx * 5;
                            }
                        }],
                    }
                );
            },
            // 工资保证金
            querySummaryMargin(){
                this.depositPie.showLoading();
                this.depositGauge.showLoading();
                this.depositScatter.showLoading();
                this.axios({
                    method: 'post',
                    url: `/summary/querySummaryMargin?areaCode=${this.areaCode || ''}`,
                    data:{
                        // areaCode:this.areaCode,
                    }
                }).then((response)=>{
                    this.depositPie.hideLoading();
                    this.depositGauge.hideLoading();
                    this.depositScatter.hideLoading();
                    if(response.data){
                        this.depositPie.setOption(
                            {
                                title:{
                                    text: '项目总数: '+response.data.pie[2].value+'个',
                                },
                                legend:{
                                    // 使用回调函数
                                    formatter: function (name) {
                                        let val=response.data.pie.filter(item=>{
                                            return item.name===name;
                                        })[0].value || 0;
                                        return name + val;
                                    }
                                },
                                series: [
                                    {
                                        data:response.data.pie.slice(0,-1)
                                    }
                                ]
                            }
                        );
                        this.depositGauge.setOption(
                            {
                                series: [
                                    {
                                        data:response.data.rate
                                    }
                                ]
                            }
                        );
                        let distribution=response.data.distribution;
                        this.depositScatter.setOption(
                            {
                                xAxis: {
                                    data: distribution.x,
                                },
                                yAxis: {
                                    data: distribution.y,
                                },
                                series: [
                                    {
                                        data: distribution.data,
                                    }
                                ],
                                dataZoom : distribution.x.length > 6 ? [
                                    {
                                        startValue : 0,
                                        endValue : 6,
                                        type: 'slider',
                                        show: true,
                                        xAxisIndex: [0],
                                        height: 10,
                                        bottom: 8,
                                        borderRadius: 5,
                                        showDataShadow: false,
                                        showDetail: false,
                                        realtime: true
                                    }
                                ] : [],
                            }
                        );
                    }
                });
            },
            /* 获取页面数据 */
            getPageData(){
                this.querySummaryMargin();
            },
        }
    };
</script>
